import { Node } from "../../node.js";
/**
 * @public
 */
export function hasHeadingLevel(device, predicate = (n) => !isNaN(n)) {
    return (element) => Node.from(element, device)
        .attribute("aria-level")
        .map((level) => Number(level.value))
        .some(predicate);
}
//# sourceMappingURL=has-heading-level.js.map